import { getSafeExternalUrl } from "./security";

const HTTPS_LINK_PATTERN = /(https:\/\/[^\s]+)/g;

export function splitMessageText(text = "") {
  return String(text)
    .split(HTTPS_LINK_PATTERN)
    .filter(Boolean)
    .map((part) => {
      const safeUrl = part.startsWith("https://") ? getSafeExternalUrl(part) : "";
      return { isLink: Boolean(safeUrl), text: part, ...(safeUrl ? { url: safeUrl } : {}) };
    });
}
